export function HTMlfromString(HTMLstring) {
  let doc = new DOMParser().parseFromString(HTMLstring, "text/html")
  return doc.body
}
export function getTextContextLength(node) {
  return node.textContent.length
}
